import { Chip, Stack, Typography } from "@mui/material";

const TitleHeading = ({
    title,
    textAlign,
    chipLabel="",
    chipIcon=null,
    chipColor="primary.main",
    chipAlignment
}) => {
    return (
        <>
            <Stack
                direction='row'
                justifyContent={{xs: 'center', md: chipAlignment}}
                data-aos="slide-up"
            >
                <Chip 
                    label={chipLabel} 
                    icon={chipIcon}
                    sx={{
                        p: 1,
                        mb: 2,
                        backgroundColor: chipColor,
                        color: 'white',
                        fontWeight: 900,
                        display: chipLabel ? 'flex' : 'none',
                        width: 'fit-content'
                    }}
                />
            </Stack>

            <Typography
                fontWeight={800}
                fontSize={{xs: 20, md: 32}}
                lineHeight={1.25}
                textAlign={{xs: 'center', md: textAlign}}
                data-aos="slide-up"
            >
                {title}
            </Typography>
        </>
    );
}

export default TitleHeading;